var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M19 5.231a1.385 1.385 0 0 0-1.385-1.385h-2.769L12.77 1.077H7.231l-2.077 2.77h-2.77A1.385 1.385 0 0 0 1 5.23v8.308a1.384 1.384 0 0 0 1.385 1.384h15.23A1.384 1.384 0 0 0 19 13.54z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10 11.808a3.115 3.115 0 1 0 0-6.23 3.115 3.115 0 0 0 0 6.23"
})));
export default SvgCamera;